<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar class="mb-2">
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button id="back_to_overview"
        [label]="'global.back_to_overview' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.BACK"
      routerLink="/users"></button>
    </div>
  </medsurf-design-content-toolbar>
  <!-- Content -->
  <div class="flex flex-1 overflow-auto justify-content-center align-self-center w-11 lg:w-5 mb-2">
    @if ({
      isNew: (userSharedFacade.user$ | async) === undefined
    }; as data) {
      <div
        class="flex flex-column row-gap-2 w-full">
        <medsurf-design-content-panel titleText="global.user">
          <!-- Form -->
          @if (userForm) {
            <medsurf-design-form-control-form
              [formGroup]="userForm"
              (onSubmit)="onSubmit()">
              <!-- Email -->
              <medsurf-design-form-control-input-text [control]="userForm.controls.email"
                inputType="email"
              label="global.email"></medsurf-design-form-control-input-text>
              <!-- Role -->
              <medsurf-design-form-control-input-dropdown [control]="userForm.controls.role"
                [options]="FlatModels.UserEntityModels.RoleArray"
              label="global.role"></medsurf-design-form-control-input-dropdown>
              <!-- First Name -->
              <medsurf-design-form-control-input-text [control]="userForm.controls.firstName"
                inputType="text"
              label="global.first_name"></medsurf-design-form-control-input-text>
              <!-- Last Name -->
              <medsurf-design-form-control-input-text [control]="userForm.controls.lastName"
                inputType="text"
              label="global.last_name"></medsurf-design-form-control-input-text>
              <!-- Submit -->
              <medsurf-design-form-control-input-submit [disabled]="userForm.invalid || isSubmitted()"
              label="global.save_changes"></medsurf-design-form-control-input-submit>
              <!-- New User Message -->
              <div class="flex mb-2">
                @if (data.isNew) {
                  <medsurf-design-content-message
                    text="medsurf-user-detail.new_user_message"
                  class="w-full"></medsurf-design-content-message>
                }
              </div>
            </medsurf-design-form-control-form>
          }
        </medsurf-design-content-panel>
        <!-- Delete Panel -->
        <medsurf-design-content-panel titleText="global.user_remove"
          [hidden]="data.isNew && !canDelete()">
          <button medsurf-design-input-button id="user_remove"
            [label]="'global.remove' | translate"
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
            [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
          (click)="deleteUser()"></button>
        </medsurf-design-content-panel>
      </div>
    }
  </div>
</div>
